import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';


import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import DialogTitle from '@material-ui/core/DialogTitle';

import Grid from '@material-ui/core/Grid';


import SettingsProduct from '../settings/Product';
import SettingsMaterial from '../settings/Material';
import SettingsMedium from '../settings/Medium';
import SettingsCladding from '../settings/Cladding';
import SettingsEnergySource from '../settings/EnergySource';


import { add, patch, remove, patchSettings } from '../../modules/data/settings';
import { closeSetting } from '../../modules/app';

import { getCustomArrayName, getType } from '../../modules/data/customs';

import { getUIText } from '../../utils/index';

import { version as applicationVersion } from '../../utils/application-version';

class Settings extends React.Component {

  constructor(props) {
    super(props);
    const {
      menuLayout,

      claddings,
      energy,
      mediums,
      materials,
      products,
    } = this.props;

    this.state = {
      claddings: claddings.data,
      energy: energy.data,
      mediums: mediums.data,
      materials: materials.data,
      products: products.data,

      newItemsIds: [],
      patchItemsIds: [],
      deletedItemsIds: [],

      menuLayout: menuLayout ? menuLayout : 0,
      unsaved: false,
      showWarning: false,
      showWarningDialog: false,
      changedIds: []
    };
  }

  cancel() {
    const {
      closeSetting
    } = this.props;

    closeSetting();
  }

  menuClickHandler(id) {
    this.setState({menuLayout: id});
  }

  saveSettings() {
    if(this.state.showWarning) {
      this.setState({showWarningDialog: true, showWarning: false});
      return;
    }

    const {
      onPatchSettings,
      closeSetting,

    } = this.props;

    this.setState({unsaved: false});

    const items = [
      ...this.state.claddings,
      ...this.state.energy,
      ...this.state.mediums,
      ...this.state.materials,
      ...this.state.products,
    ];

    const data = {
      newItems: this.state.newItemsIds.map( item => {
        const o = {
          item: items.find( m => {
            return m.Nid === item.id;
          }),
          type: getType(item)
        };
        return o;
      }),
      patchItems: this.state.patchItemsIds.map( item => {
        const o = {
          item: items.find( m => {
            return m.Nid === item.id;
          }),
          type: getType(item)
        };
        return o;
      }),
      deletedItems: this.state.deletedItemsIds
    };

    onPatchSettings(data);
    closeSetting();
  }

  onAdd(data) {
    console.log('onAdd', data);

    if(data) {
      const name = getCustomArrayName(data);

      const o = {
        unsaved: true,
        newItemsIds: [
          ...this.state.newItemsIds,
          {id: data.item.Nid, type: data.type}
        ]
      };
      o[name] = [
        ...this.state[name],
        data.item
      ];
      this.setState(o);
    }
  }

  onPatch(data) {
    console.log('onPatch', data);

    if(data) {
      const name = getCustomArrayName(data);

      let patchItemsIds = this.state.patchItemsIds;
      if(!this.state.newItemsIds.find( item => { return item.id === data.item.Nid; }) && !this.state.patchItemsIds.find( item => { return item.id === data.item.Nid; })) {
        patchItemsIds = [
          ...this.state.patchItemsIds,
          {id: data.item.Nid, type: data.type}
        ];
      }

      const o = {
        unsaved: true,
        patchItemsIds: patchItemsIds
      };
      o[name] = this.state[name].map( item => {
        if(item.Nid === data.item.Nid) {
          return data.item;
        }
        return item;
      });
      this.setState(o);
    }
  }

  onRemove(data) {
    console.log('onRemove', data);

    if(data) {
      const name = getCustomArrayName(data);
      const index = this.state[name].findIndex( (item) => {
        return item.Nid === data.id;
      });

      let deletedItemsIds = this.state.deletedItemsIds;
      if(!this.state.deletedItemsIds.find( item => { return item.id === data.id; }) && !this.state.newItemsIds.find( item => { return item.id === data.id; }) ) {
        let id = data.id;
        const toBeDeletedItem = this.state[name][index];
        if(toBeDeletedItem && toBeDeletedItem.hasOwnProperty('uuid')) {
          id = toBeDeletedItem.uuid;
        }

        deletedItemsIds = [
          ...this.state.deletedItemsIds,
          {
            ...data,
            id: id
          }
        ];
      }

      const o = {
        showWarning: true,
        unsaved: true,
        deletedItemsIds: deletedItemsIds,
        newItemsIds: this.state.newItemsIds.filter( item => {
          return item !== data.id;
        }),
        patchItemsIds: this.state.patchItemsIds.filter( item => {
          return item !== data.id;
        }),
      };

      o[name] = [
        ...this.state[name].slice(0, index),
        ...this.state[name].slice(index + 1)
      ];
      this.setState(o);
    }
  }

  render() {
    const {
      closeSetting,
      translations,
      app,
      open,
      user,
      onAdd,
      onPatch,
      onRemove,
    } = this.props;

    let contentLayout;
    if(this.state.menuLayout === 0) {
      contentLayout = (<div className="content">
        <p>{getUIText('SETTINGS-APPLICATION_VERSION', app.language, translations)}: <b>{applicationVersion}</b></p>
        <p><b>{getUIText('SETTINGS-UPDATE_DISCLAIMER', app.language, translations)}</b><br />
        {getUIText('STARTUP_DIALOG-DISCLAIMER', app.language, translations)}</p>
      </div>);
    } else if(this.state.menuLayout === 1) {
      contentLayout = (<div className="content">
        <SettingsProduct
          translations={translations}
          app={app}
          items={this.state.products}
          create={ (data) => {this.onAdd(data);}}
          patch={ (data) => {this.onPatch(data);}}
          remove={ (data) => {this.onRemove(data);}}
          />
      </div>);
    } else if(this.state.menuLayout === 2) {
      contentLayout = (<div className="content">
        <SettingsMaterial
          translations={translations}
          app={app}
          items={this.state.materials}
          create={ (data) => {this.onAdd(data);}}
          patch={ (data) => {this.onPatch(data);}}
          remove={ (data) => {this.onRemove(data);}}
          />
      </div>);
    } else if(this.state.menuLayout === 3) {
      contentLayout = (<div className="content">
        <SettingsMedium
          translations={translations}
          app={app}
          items={this.state.mediums}
          create={ (data) => {this.onAdd(data);}}
          patch={ (data) => {this.onPatch(data);}}
          remove={ (data) => {this.onRemove(data);}}
          />
      </div>);
    } else if(this.state.menuLayout === 4) {
      contentLayout = (<div className="content">
        <SettingsCladding
          translations={translations}
          app={app}
          items={this.state.claddings}
          create={ (data) => {this.onAdd(data);}}
          patch={ (data) => {this.onPatch(data);}}
          remove={ (data) => {this.onRemove(data);}}
          />
      </div>);
    } else if(this.state.menuLayout === 5) {
      contentLayout = (<div className="content">
        <SettingsEnergySource
          translations={translations}
          app={app}
          items={this.state.energy}
          create={ (data) => {this.onAdd(data);}}
          patch={ (data) => {this.onPatch(data);}}
          remove={ (data) => {this.onRemove(data);}}
          />
      </div>);
    }

    return (
      <Dialog className="settings" open={open} fullWidth maxWidth="md" >
        <DialogTitle>{getUIText('SETTINGS-TITLE', app.language, translations)}</DialogTitle>
        <DialogContent>
          <Grid container spacing={0}>
            <Grid item xs={12} md={4}>
              <div className="menu">
                <Button color="primary" disabled={this.state.menuLayout === 0 ? true : false} onClick={this.menuClickHandler.bind(this, 0)}>
                  {getUIText('SETTINGS-ABOUT_PROGRAM', app.language, translations)}
                </Button>
                <Button color="primary" disabled={this.state.menuLayout === 1 ? true : false} onClick={this.menuClickHandler.bind(this, 1)}>
                  {getUIText('SETTINGS-CUSTOM_PRODUCTS', app.language, translations)}
                </Button>
                <Button color="primary" disabled={this.state.menuLayout === 2 ? true : false} onClick={this.menuClickHandler.bind(this, 2)}>
                  {getUIText('SETTINGS-CUSTOM_MATERIAL', app.language, translations)}
                </Button>
                <Button color="primary" disabled={this.state.menuLayout === 3 ? true : false} onClick={this.menuClickHandler.bind(this, 3)}>
                  {getUIText('SETTINGS-CUSTOM_MEDIUMS', app.language, translations)}
                </Button>
                <Button color="primary" disabled={this.state.menuLayout === 4 ? true : false} onClick={this.menuClickHandler.bind(this, 4)}>
                  {getUIText('SETTINGS-CUSTOM_CLADDINGS', app.language, translations)}
                </Button>
                <Button color="primary" disabled={this.state.menuLayout === 5 ? true : false} onClick={this.menuClickHandler.bind(this, 5)}>
                  {getUIText('SETTINGS-CUSTOM_ENERGY_SOURCES', app.language, translations)}
                </Button>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              {contentLayout}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={this.cancel.bind(this)}>
            {getUIText('GENERAL-CANCEL', app.language, translations)}
          </Button>
          <Button color="primary" disabled={!this.state.unsaved} autoFocus onClick={this.saveSettings.bind(this)}>
            {getUIText('GENERAL-SAVE', app.language, translations)}
          </Button>
        </DialogActions>
        <Dialog open={this.state.showWarningDialog} >
          <DialogTitle>{getUIText('DIALOG_PROJECT-SAVE-TITLE', app.language, translations)}</DialogTitle>
          <DialogContent>
            {getUIText('SETTINGS-DELETING_WARNING', app.language, translations)}
          </DialogContent>
          <DialogActions>
            <Button color="primary" autoFocus onClick={this.saveSettings.bind(this)}>
              {getUIText('GENERAL-OK', app.language, translations)}
            </Button>
          </DialogActions>
        </Dialog>
      </Dialog>
    );
  }
}

Settings.propTypes = {
    app: PropTypes.object,
    project: PropTypes.object,
    translations: PropTypes.object,
    user: PropTypes.object,

    claddings: PropTypes.object,
    energy: PropTypes.object,
    mediums: PropTypes.object,
    materials: PropTypes.object,
    products: PropTypes.object,
  menuLayout: PropTypes.any,
  closeSetting: PropTypes.any,
  onPatchSettings: PropTypes.any,
  open: PropTypes.any,
  onAdd: PropTypes.any,
  onPatch: PropTypes.any,
  onRemove: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
      app: state.app,
      translations: state.translations,
      project: state.project,
      user: state.user,

      claddings: state.claddings,
      energy: state.energy,
      mediums: state.mediums,
      materials: state.materials,
      products: state.products,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      closeSetting: () => dispatch(closeSetting()),
      onAdd: (data) => dispatch(add(data)),
      onPatch: (data) => dispatch(patch(data)),
      onRemove: (data) => dispatch(remove(data)),

      onPatchSettings: (data) => dispatch(patchSettings(data)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Settings);
